const getHostname = (url) => {
    // use URL constructor and return hostname
    return new URL(url).hostname;
}

let host = window.location.origin;
let finalHostName = getHostname(host);


const ENV = {
 base: `https://${finalHostName}/api`,
 //   base: "https://democenter.taskus.com/api",
    botbase: "https://democenter.taskus.com/",
    websocket_url: "wss://democenter.taskus.com/ws/process_file_for_embeddings",
    websocket_receiver: "democenter.taskus",
    websocket_environment: "prod",
    cfFlag: "true",
    product_title: "Demo Center",
    ping: {
      client_id: "556978fb-aaf3-45e8-aca9-5455add3d6c5",
      auth_url:
        "https://sso.connect.pingidentity.com/sso/as/authorization.oauth2",
      redirect_uri: "https://democenter.taskus.com",
    },
    smartFloBaseUrl: "https://smartflo.taskus.com",
    smartFloApiBaseUrl: "https://smartflo.taskus.com/api",
    accountID: "3817830",
    trustKey: "3817830",
    agentID: "1386209481",
    licenseKey: "NRBR-ccffa55d87d34bf9829",
    applicationID: "1386209481",
    beacon: "bam.nr-data.net",
    errorBeacon: "bam.nr-data.net",
    sa: 1,
};

export const getEnv = () => {
    return ENV;
};

